import React, { Component } from 'react';
import {connect} from "react-redux";
import viewHelper from '../../helpers/view';
import ProfileInfo from './profileInfo';
import Spinner from '../shared/spinner';
import MemberInfo from '../shared/memberInfo';
import { fetchMembership } from '../../actions/members';

class Membership extends Component {

    componentDidMount() {
        let membershipId = this.props.match.params.id;
        this.props.fetchMembership(membershipId);
    }

    render () {
        const { member, membership } = this.props;
        if (!membership) {
            return ( <div> <Spinner /> </div> );
        } else {
            return (
                <div className="container content">
                    <MemberInfo title={`${viewHelper.getFullName(member)} - ${membership.activity}`} />
                    <div className="col-md-2 col-xs-12 col-lg-2 text-center">
                        <img alt="" src={member.profile_image_url} className="img-circle profile-image"/>
                    </div>
                    <div className="col-md-10 col-xs-12 col-lg-10 profile-info mb-15">
                        <div className="col-md-6 col-lg-6 col-xs-12 no-padding">
                            <ProfileInfo title='Contract No.'      info={membership.id} />
                            <ProfileInfo title='Status'            info={membership.status} />
                            <ProfileInfo title='Payment Type'      info={membership.payment_type} />
                            <ProfileInfo title='Amount'            info={viewHelper.formatCurrency(membership.total_amount)} />
                            <ProfileInfo title='Starts On'         info={viewHelper.getFormattedDate(membership.start_date)} />
                            <ProfileInfo title='Ends On'           info={viewHelper.getFormattedDate(membership.end_date)} />
                            <ProfileInfo title='Visits'            info={membership.visits} />
                            <ProfileInfo title='Visits Remaining'  info={membership.visits_remaining} />
                        </div>
                        <div className="col-md-6 col-lg-6 col-xs-12 no-padding">
                            <ProfileInfo title='Enrollment Fee'        info={membership.enrollment_fee} />
                            <ProfileInfo title='Down Payment'          info={membership.down_payment} />
                            <ProfileInfo title='Billing Contract No'   info={membership.billing_id} />
                            <ProfileInfo title='Auto Renew'            info={membership.auto_renew} />
                            <ProfileInfo title='Cancel Date'           info={membership.cancel_date} />
                            <ProfileInfo title='Cancelled By'          info={membership.cancelled_by} />
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    const { membership } = state;
    return {
        membership
    };
}

export default connect(mapStateToProps, { fetchMembership })(Membership);



// WEBPACK FOOTER //
// ./src/components/members/membership.js